import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDimensions } from '@libs/hooks';
import { screenSizes } from '@libs/theme';
import { useRef } from 'react';
import { DropdownIcon } from '../assets';
import Typography from '../typography/Typography';
import { ChildrenWrapper, DropdownContainer, IconWrapper, TitleWrapper, } from './styles';
const Dropdown = ({ title, children, isOpen, onClick, className, shouldIconShow = true, }) => {
    const ref = useRef(null);
    const { width } = useDimensions();
    const contentHeight = ref.current?.scrollHeight;
    return (_jsxs(DropdownContainer, { className: className, children: [_jsxs(TitleWrapper, { onClick: onClick, shouldIconShow: shouldIconShow, children: [_jsx(Typography, { type: width > screenSizes.tabletL ? 'titleTwo' : 'subHeadline', fontFamily: "primaryBold", className: "title", children: title }), shouldIconShow && (_jsx(IconWrapper, { isOpen: isOpen, className: "icon", children: _jsx(DropdownIcon, {}) }))] }), _jsx(ChildrenWrapper, { isOpen: isOpen, ref: ref, contentHeight: contentHeight ? contentHeight / 10 : 0, children: children })] }));
};
export default Dropdown;
//# sourceMappingURL=Dropdown.js.map